import {
    useInfiniteQuery,
    useMutation,
    useQueryClient,
} from "@tanstack/vue-query";
import axios from "axios";
import route from "ziggy-js";

const QUERY_KEY = ["ACTIVITY_HISTORY"];

async function addComment({ task, contents, type, documents }) {
    return axios.post(route("api.tasks.comment", task), {
        contents: contents,
        type: type,
        document_ids: documents,
    });
}

export function useAddComment() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addComment,
        onMutate: async (newComment) => {
            await queryClient.cancelQueries({ queryKey: QUERY_KEY });

            const previousComments = queryClient.getQueryData(QUERY_KEY);

            queryClient.setQueryData(QUERY_KEY, (old) => {
                return {
                    ...old,
                    pages: old.pages.map((page, index) =>
                        index === 0
                            ? {
                                  ...page,
                                  comments: [newComment, ...page.data],
                              }
                            : page
                    ),
                };
            });

            return { previousComments };
        },
        onError: (err, _, context) => {
            queryClient.setQueryData(QUERY_KEY, context.previousComments);
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: QUERY_KEY });
        },
    });
}

async function fetchActivityHistory({ tenant, task, pageParam = 0 }) {
    const { data } = await axios.get(
        route("api.tasks.feed.index", {
            tenant,
            task,
            cursor: pageParam,
        })
    );
    return data;
}

export function useActivityHistory(tenant, task) {
    return useInfiniteQuery({
        queryKey: QUERY_KEY,
        queryFn: ({ pageParam }) =>
            fetchActivityHistory({ tenant, task, pageParam }),
        initialPageParam: 0,
        getNextPageParam: (lastPage) => lastPage.meta.next_cursor,
        refetchOnMount: true,
    });
}
